import Immutable from 'immutable';
import { confirmLexicalStateInTextComponent } from 'modules/draftjs2lexical';
import * as lexical from 'modules/Lexical/helpers/referenceCitations';
import * as Models from 'models';
import { getApplicableForTextCompnentFirstLayeredRelationStyles } from './utils';

type Results = {
  updatedDocuments: Models.TextComponents;
  updatedRelations: Models.LayeredRelations<Models.TextRelationStyles>;
};

export function deleteReferenceCitationFromComponents(
  referenceCitationId: string,
  textComponents: Models.TextComponentsMap,
  layeredRelations: Models.LayeredRelationsMap,
  componentIds: Immutable.List<string> | undefined,
): Results {
  const updatedRelations: Models.LayeredRelations<Models.TextRelationStyles> = {};

  const textComponentIds = componentIds || textComponents.keySeq().toList();
  const textsToUpdate = textComponents.filter((textComponent, textComponentId) => Boolean(
    textComponent
    && textComponentId
    && textComponent.get('referenceCitations').includes(referenceCitationId)
    && textComponentIds.includes(textComponentId),
  ));

  const updatedDocuments: Models.TextComponents = textsToUpdate.map((textComponent, textComponentId) => {
    if (!textComponent || !textComponentId) {
      return textComponent;
    }

    const component = confirmLexicalStateInTextComponent(
      textComponent,
      getApplicableForTextCompnentFirstLayeredRelationStyles(textComponentId, layeredRelations),
    );

    return lexical.removeReferenceCitationIdOnComponent(component, referenceCitationId);

  }).toJS() as Models.TextComponents;

  return {
    updatedDocuments,
    updatedRelations,
  };
}
